var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { width: 1200 } },
    [
      _c("Loading", {
        attrs: { isLoading: _vm.saveLoading, text: _vm.LoadingText },
      }),
      _vm.innerSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            height: "500px",
            overflow: "scroll",
            "padding-left": "20px",
            "padding-right": "20px",
          },
        },
        [
          _c(
            "Form",
            {
              ref: "productForm",
              staticClass: "small-form",
              attrs: {
                model: _vm.productForm,
                rules: _vm.ruleValidate,
                "label-position": "top",
              },
            },
            [
              _c(
                "div",
                { staticClass: "productInfoWrap" },
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "名称", prop: "productName" } },
                            [
                              _c("Input", {
                                on: { "on-change": _vm.productNameChange },
                                model: {
                                  value: _vm.productForm.productName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productName",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.productName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "大类",
                                prop: "productMainCategoryUuid",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { transfer: "" },
                                  model: {
                                    value:
                                      _vm.productForm.productMainCategoryUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productMainCategoryUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n                                        productForm.productMainCategoryUuid\n                                    ",
                                  },
                                },
                                _vm._l(
                                  _vm.popupEditResource.mainCategorySource,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.mainCategoryUuid,
                                        attrs: { value: item.mainCategoryUuid },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(item.mainCategoryName) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "小类",
                                prop: "productSubCategoryUuid",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", transfer: "" },
                                  model: {
                                    value:
                                      _vm.productForm.productSubCategoryUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productSubCategoryUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "productForm.productSubCategoryUuid",
                                  },
                                },
                                _vm._l(_vm.subCategorySource, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.subCategoryUuid,
                                      attrs: { value: item.subCategoryUuid },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.subCategoryName) +
                                          "\n                                        " +
                                          _vm._s(item.brand)
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: { label: "产品形态", prop: "productForm" },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { transfer: "" },
                                  model: {
                                    value: _vm.productForm.productForm,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productForm",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.productForm",
                                  },
                                },
                                _vm._l(_vm.formOptions, function (ft) {
                                  return _c(
                                    "Option",
                                    { key: ft, attrs: { value: ft } },
                                    [_vm._v(_vm._s(ft))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "品牌",
                                prop: "productBrandUuid",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: {
                                    disabled: "",
                                    filterable: "",
                                    transfer: "",
                                  },
                                  model: {
                                    value: _vm.productForm.productBrandUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productBrandUuid",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.productBrandUuid",
                                  },
                                },
                                _vm._l(
                                  _vm.popupEditResource.brandSource,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.brandUuid,
                                        attrs: { value: item.brandUuid },
                                      },
                                      [_vm._v(_vm._s(item.brandName))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "颜色", prop: "productColor" } },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.productColor,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productColor",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.productColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { prop: "productPackageUuid" } },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [_vm._v("纸箱")]
                              ),
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", transfer: "" },
                                  model: {
                                    value: _vm.productForm.productPackageUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productPackageUuid",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "productForm.productPackageUuid",
                                  },
                                },
                                _vm._l(
                                  _vm.popupEditResource.packageSource,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.packageUuid,
                                        attrs: { value: item.packageUuid },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.packageName +
                                              " " +
                                              item.packageRemark
                                          )
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "装箱量",
                                prop: "productPackageQuantity",
                              },
                            },
                            [
                              _c("integer-input", {
                                attrs: {
                                  min: 0.01,
                                  max: 1000000,
                                  precision: this.getUnitisByUuidRounded(
                                    _vm.productForm.productUnitUuid
                                  ),
                                },
                                model: {
                                  value: _vm.productForm.productPackageQuantity,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productPackageQuantity",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "productForm.productPackageQuantity",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: { label: "单位", prop: "productUnitUuid" },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", transfer: "" },
                                  model: {
                                    value: _vm.productForm.productUnitUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productUnitUuid",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.productUnitUuid",
                                  },
                                },
                                _vm._l(
                                  _vm.popupEditResource.unitSource,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.unitUuid,
                                        attrs: { value: item.unitUuid },
                                      },
                                      [_vm._v(_vm._s(item.unitName))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "规格" } },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.productSpec,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productSpec",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.productSpec",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "包装费(箱/元)",
                                prop: "packingFee",
                              },
                            },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.packingFee,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.productForm, "packingFee", $$v)
                                  },
                                  expression: "productForm.packingFee",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "配送费(箱/元)",
                                prop: "deliveryFee",
                              },
                            },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.deliveryFee,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "deliveryFee",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.deliveryFee",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "最小单位指标",
                                prop: "productIncreaseStepAmount",
                              },
                            },
                            [
                              _c("decimal-input", {
                                attrs: {
                                  precision: this.getUnitisByUuidRounded(
                                    _vm.productForm.productUnitUuid
                                  ),
                                },
                                model: {
                                  value:
                                    _vm.productForm.productIncreaseStepAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productIncreaseStepAmount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "productForm.productIncreaseStepAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "最低起订量",
                                prop: "productMinOrderAmount",
                              },
                            },
                            [
                              _c("decimal-input", {
                                attrs: {
                                  precision: this.getUnitisByUuidRounded(
                                    _vm.productForm.productUnitUuid
                                  ),
                                },
                                model: {
                                  value: _vm.productForm.productMinOrderAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productMinOrderAmount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "productForm.productMinOrderAmount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "定金比例(%)",
                                prop: "productPreSaleDepositRatio",
                              },
                            },
                            [
                              _c("integer-input", {
                                attrs: { min: 0, max: 100 },
                                model: {
                                  value:
                                    _vm.productForm.productPreSaleDepositRatio,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productPreSaleDepositRatio",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "\n                                        productForm.productPreSaleDepositRatio\n                                    ",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "系列",
                                prop: "productSerialUuid",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { filterable: "", transfer: "" },
                                  model: {
                                    value: _vm.productForm.productSerialUuid,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productSerialUuid",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.productSerialUuid",
                                  },
                                },
                                _vm._l(
                                  _vm.popupEditResource.serialSource,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.serialUuid,
                                        attrs: { value: item.serialUuid },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item.serialName) +
                                            "\n                                        " +
                                            _vm._s(item.brand)
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "苗高(cm)",
                                prop: "seedlingHeight",
                              },
                            },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.seedlingHeight,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "seedlingHeight",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.seedlingHeight",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: { label: "对叶数", prop: "leavesNumber" },
                            },
                            [
                              _c("Input", {
                                model: {
                                  value: _vm.productForm.leavesNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "leavesNumber",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.leavesNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "盘数(如100穴/盘)",
                                prop: "pottingSeedling",
                              },
                            },
                            [
                              _c("integer-input", {
                                staticClass: "width50",
                                attrs: {
                                  min: 0,
                                  precision: this.getUnitisByUuidRounded(
                                    _vm.productForm.productUnitUuid
                                  ),
                                },
                                model: {
                                  value: _vm.productForm.pottingSeedling,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "pottingSeedling",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.pottingSeedling",
                                },
                              }),
                              _c(
                                "Select",
                                {
                                  staticClass: "width50",
                                  attrs: { filterable: "", transfer: "" },
                                  model: {
                                    value: _vm.productForm.pottingSeedlingUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "pottingSeedlingUnit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "productForm.pottingSeedlingUnit",
                                  },
                                },
                                _vm._l(
                                  _vm.pottingSeedlingUnit,
                                  function (item) {
                                    return _c(
                                      "Option",
                                      { key: item, attrs: { value: item } },
                                      [_vm._v(_vm._s(item))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.$checkAccessArray(["B"])
                    ? _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c("Col", { attrs: { span: "16" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "red",
                                  padding: "5px 0px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                温馨提示：为确保客户端图片显示效果良好,请上传宽高比为1:1.1的图片（如宽750px-高825px）\n                            "
                                ),
                              ]
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "成品图",
                                prop: "productFinishImageFile",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "img-card" },
                                [
                                  _c("single-file-upload-with-name", {
                                    ref: "productFinishImageFileImg",
                                    attrs: { imgHeight: 150, imgWidth: 150 },
                                    model: {
                                      value:
                                        _vm.productForm.productFinishImageFile,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.productForm,
                                          "productFinishImageFile",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "\n                                            productForm.productFinishImageFile\n                                        ",
                                    },
                                  }),
                                  _vm.productForm.productFinishImageFile !=
                                    "" &&
                                  _vm.productForm.productFinishImageFile != null
                                    ? _c("Icon", {
                                        staticClass: "icon-delete",
                                        staticStyle: { "margin-top": "-30px" },
                                        attrs: { type: "ios-eye" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showImageModal(
                                              "productFinishImageFileImg"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm.productForm.productFinishImageFile !=
                                    "" &&
                                  _vm.productForm.productFinishImageFile != null
                                    ? _c("Icon", {
                                        staticClass: "icon-delete",
                                        attrs: { type: "md-trash" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteFinishImageFile()
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c("FormItem", { attrs: { label: "种苗图" } }, [
                            _c(
                              "div",
                              { staticClass: "img-card" },
                              [
                                _c("single-file-upload-with-name", {
                                  ref: "productSeedImageFile",
                                  attrs: { imgHeight: 150, imgWidth: 150 },
                                  model: {
                                    value: _vm.productForm.productSeedImageFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productSeedImageFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n                                            productForm.productSeedImageFile\n                                        ",
                                  },
                                }),
                                _vm.productForm.productSeedImageFile != "" &&
                                _vm.productForm.productSeedImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      staticStyle: { "margin-top": "-30px" },
                                      attrs: { type: "ios-eye" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showImageModal(
                                            "productSeedImageFile"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.productForm.productSeedImageFile != "" &&
                                _vm.productForm.productSeedImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      attrs: { type: "md-trash" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteSeedImageFile()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c("FormItem", { attrs: { label: "盘苗图" } }, [
                            _c(
                              "div",
                              { staticClass: "img-card" },
                              [
                                _c("single-file-upload-with-name", {
                                  ref: "productTraySeedImageFile",
                                  attrs: { imgHeight: 150, imgWidth: 150 },
                                  model: {
                                    value:
                                      _vm.productForm.productTraySeedImageFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productTraySeedImageFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n                                            productForm.productTraySeedImageFile\n                                        ",
                                  },
                                }),
                                _vm.productForm.productTraySeedImageFile !=
                                  "" &&
                                _vm.productForm.productTraySeedImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      staticStyle: { "margin-top": "-30px" },
                                      attrs: { type: "ios-eye" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showImageModal(
                                            "productTraySeedImageFile"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.productForm.productTraySeedImageFile !=
                                  "" &&
                                _vm.productForm.productTraySeedImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      attrs: { type: "md-trash" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteTraySeedImageFile()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c("FormItem", { attrs: { label: "包装图" } }, [
                            _c(
                              "div",
                              { staticClass: "img-card" },
                              [
                                _c("single-file-upload-with-name", {
                                  ref: "productPackImageFile",
                                  attrs: { imgHeight: 150, imgWidth: 150 },
                                  model: {
                                    value: _vm.productForm.productPackImageFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productPackImageFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n                                            productForm.productPackImageFile\n                                        ",
                                  },
                                }),
                                _vm.productForm.productPackImageFile != "" &&
                                _vm.productForm.productPackImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      staticStyle: { "margin-top": "-30px" },
                                      attrs: { type: "ios-eye" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showImageModal(
                                            "productPackImageFile"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.productForm.productPackImageFile != "" &&
                                _vm.productForm.productPackImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      attrs: { type: "md-trash" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deletePackImageFile()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c("FormItem", { attrs: { label: "标准卡图" } }, [
                            _c(
                              "div",
                              { staticClass: "img-card" },
                              [
                                _c("single-file-upload-with-name", {
                                  ref: "productStandardImageFile",
                                  attrs: { imgHeight: 150, imgWidth: 150 },
                                  model: {
                                    value:
                                      _vm.productForm.productStandardImageFile,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productStandardImageFile",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "\n                                            productForm.productStandardImageFile\n                                        ",
                                  },
                                }),
                                _vm.productForm.productStandardImageFile !=
                                  "" &&
                                _vm.productForm.productStandardImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      staticStyle: { "margin-top": "-30px" },
                                      attrs: { type: "ios-eye" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showImageModal(
                                            "productStandardImageFile"
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.productForm.productStandardImageFile !=
                                  "" &&
                                _vm.productForm.productStandardImageFile != null
                                  ? _c("Icon", {
                                      staticClass: "icon-delete",
                                      attrs: { type: "md-trash" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteStandardImageFile()
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "Col",
                        { attrs: { span: "4" } },
                        [
                          _c(
                            "FormItem",
                            {
                              attrs: {
                                label: "前端显示图",
                                prop: "productFontImageIndex",
                              },
                            },
                            [
                              _c(
                                "Select",
                                {
                                  attrs: { transfer: "" },
                                  model: {
                                    value:
                                      _vm.productForm.productFontImageIndex,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "productFontImageIndex",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "productForm.productFontImageIndex",
                                  },
                                },
                                [
                                  _c("Option", { attrs: { value: 1 } }, [
                                    _vm._v("成品图"),
                                  ]),
                                  _c("Option", { attrs: { value: 2 } }, [
                                    _vm._v("种苗图"),
                                  ]),
                                  _c("Option", { attrs: { value: 3 } }, [
                                    _vm._v("盘苗图"),
                                  ]),
                                  _c("Option", { attrs: { value: 4 } }, [
                                    _vm._v("包装图"),
                                  ]),
                                  _c("Option", { attrs: { value: 5 } }, [
                                    _vm._v("标准卡图"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "示范视频" } },
                            [
                              [
                                _vm.readonly == false &&
                                _vm.demonVideos.length < 5
                                  ? _c(
                                      "Upload",
                                      {
                                        attrs: {
                                          action: "https://up-z2.qiniup.com/",
                                          data: _vm.uploadParams,
                                          format: ["mp4"],
                                          accept: ".mp4",
                                          "on-format-error":
                                            _vm.handleFormatError,
                                          "on-success":
                                            _vm.handleUploadVideoSuccess,
                                          "before-upload":
                                            _vm.beforeVideoUpload,
                                          "show-upload-list":
                                            _vm.showUploadList,
                                        },
                                      },
                                      [
                                        _c(
                                          "Button",
                                          {
                                            attrs: {
                                              icon: "ios-cloud-upload-outline",
                                            },
                                          },
                                          [_vm._v("上传视频")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _c(
                                  "Row",
                                  {
                                    staticStyle: { "margin-top": "10px" },
                                    attrs: { gutter: 16 },
                                  },
                                  _vm._l(
                                    _vm.demonVideos,
                                    function (item, index) {
                                      return _c(
                                        "Col",
                                        { key: item, attrs: { span: "5" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "img-card" },
                                            [
                                              _c(
                                                "video",
                                                {
                                                  attrs: {
                                                    width: "150",
                                                    height: "150",
                                                    controls: "",
                                                  },
                                                },
                                                [
                                                  _c("source", {
                                                    attrs: {
                                                      src: item.src,
                                                      type: "video/mp4",
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _vm.readonly == false
                                                ? _c("Icon", {
                                                    staticClass: "icon-delete",
                                                    attrs: { type: "md-trash" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.deleteVideo(
                                                          index
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("Divider", { attrs: { orientation: "left", size: "small" } }, [
                _vm._v("个性合同"),
              ]),
              _c(
                "div",
                [
                  _c(
                    "Row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("Input", {
                            attrs: { rows: 5, type: "textarea" },
                            model: {
                              value: _vm.productForm.productFeatureContract,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.productForm,
                                  "productFeatureContract",
                                  $$v
                                )
                              },
                              expression: "productForm.productFeatureContract",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }